/**
 * @file Application entry point.
 */

import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {RouterProvider} from 'react-router/dom';

import {router} from './router.js';
import './styles/globals.css';

const container = document.querySelector('#root');
if (container === null) {
  throw new Error('Root container #root is missing from the document.');
}

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
